import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import * as ReactDOM from "react-dom";
import Game from "./Game";
import ManageGameRelease from "./ManageGame/ManageGameRelease";
import ManageGameSecurity from "./ManageGame/ManageGameSecurity";
import ManageGameProduct from "./ManageGame/ManageGameProduct";
import ManageGamePage from "./ManageGame/ManageGamePage";
import ManageGameCategory from "./ManageGame/ManageGameCategory";
import ManageGameGeneral from "./ManageGame/ManageGameGeneral";
import {format} from "react-string-format";
import ManageGameLinks from "./ManageGame/ManageGameLinks";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import {Col, Container, Row} from "react-bootstrap";

export default class ManageGame extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            isLoaded: false,
            game: null,
            lastRelease: null,
            hasChat: false,
            settings: null,
            isSettingsLoaded: false,
        };
    }

    componentDidMount() {
        console.log(JSON.stringify(this.props));
        if(this.props.gameId) {
            fetch(process.env.REACT_APP_API_URL + "/publisher/game/" + this.props.gameId.toString() + "/stats", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            isLoaded: true,
                            game: result.game,
                            lastRelease: result.last_release
                        });
                    },

                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )

            fetch(process.env.REACT_APP_API_URL + "/chat/game/" + this.props.gameId.toString() + "/id", {
                headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
            })
                .then(res => res.json())
                .then(
                    (result) => {
                        this.setState({
                            hasChat: result.chat_id > -1
                        });
                    },
                )
        }

        fetch(process.env.REACT_APP_API_URL + "/settings/1", {
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        })
            .then(res => res.json())
            .then(
                (result) => {
                    console.log(result);
                    this.setState({
                        isSettingsLoaded: true,
                        settings: result
                    });
                },
                (error) => {
                    this.setState({
                        isSettingsLoaded: true,
                        error
                    });
                }
            )
    }

    releaseGame(e) {
        e.preventDefault();

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/release', this.props.gameId.toString()), {
            method: "PUT",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    window.location.reload(false);
                }
            );
    }

    releaseDemo(e) {
        e.preventDefault();

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/demo', this.props.gameId.toString()), {
            method: "PUT",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    window.location.reload(false);
                }
            );
    }

    hideGame(e) {
        e.preventDefault();

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}/draft', this.props.gameId.toString()), {
            method: "PUT",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    window.location.reload(false);
                }
            );
    }

    submitForReview(e) {
        e.preventDefault();

        const body = {'status': 'ready_for_review'};

        fetch(format(process.env.REACT_APP_API_URL + '/publisher/game/{0}', this.props.gameId.toString()), {
            method: "PUT",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    window.location.reload(false);
                }
            );
    }

    createChat(e) {
        e.preventDefault();

        const body = {'game_id': this.props.gameId};

        fetch(process.env.REACT_APP_API_URL + '/chat', {
            method: "POST",
            body: JSON.stringify(body),
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`},
        }).then(res => res.json())
            .then(
                (result) => {
                    window.location.reload(false);
                }
            );
    }

    render() {
        const { error, hasChat, isLoaded, game, lastRelease, settings, isSettingsLoaded } = this.state;

        let content = null;

        if (error) {
            content = <div>{error ? <div className="alert alert-danger">
                <p>Session token has expired. Please, <a href="/account">login</a> again</p>
            </div> :<empty/>}</div>;
        } else if (!isLoaded || !isSettingsLoaded) {
            content = <div>Loading...</div>;
        } else {
            content = <div>
                <center><h1>{game.name}</h1></center>
                <h3>Status: {game.status.replace('_', ' ').replace('_', ' ')}</h3>
                <h3>{game.approved ? 'Approved' : 'Not approved yet'}</h3>
                {game.approved ?
                    <div>
                        {game.status != 'active' ? <form className="col-sm-2" onSubmit={this.releaseGame.bind(this)}>
                                <input className="btn btn-success" type="submit" value="Release"/>
                            </form> : <empty/>}

                        <form class="col-sm-2 ms-3" onSubmit={this.releaseDemo.bind(this)}>
                            <input className="btn btn-outline-success" type="submit" value="Release as demo"/>
                        </form>

                        <form class="col-sm-2 ms-3" onSubmit={this.hideGame.bind(this)}>
                            <input className="btn btn-dark" type="submit" value="Hide"/>
                        </form>
                    </div>
                    :
                    <div class="row">
                        {game.status !== 'ready_for_review' && game.status !== 'in_review' && game.status !== 'update_in_review'
                            ? <form className="col-sm-2" onSubmit={this.submitForReview.bind(this)}>
                                <input className="btn btn-outline-primary" type="submit" value="Submit for review"/>
                            </form> : <empty/>}

                        <form class="col-sm-2 ms-3" onSubmit={this.releaseDemo.bind(this)}>
                            <input className="btn btn-success" type="submit" value="Release as demo"/>
                        </form>

                        <form className="col-sm-2 ms-3" onSubmit={this.hideGame.bind(this)}>
                            <input className="btn btn-dark" type="submit" value="Hide"/>
                        </form>
                    </div>
                }
                <br/>

                <Tabs
                    defaultActiveKey="general"
                    id="uncontrolled-tab-example"
                    className="mb-3"
                >
                    <Tab eventKey="general" title="General">
                        <ManageGameGeneral settings={settings} game={game}/>
                    </Tab>
                    <Tab eventKey="page" title="Page">
                        <ManageGamePage settings={settings} game={game}/>
                    </Tab>
                    <Tab eventKey="release" title="Release">
                        <ManageGameRelease settings={settings} game={game} last_release={lastRelease}/>
                    </Tab>
                    <Tab eventKey="security" title="Security">
                        <ManageGameSecurity settings={settings} game={game}/>
                    </Tab>
                    <Tab eventKey="product" title="Product">
                        <ManageGameProduct settings={settings} companyIsFullType={game.publisher.type_full} game={game}/>
                    </Tab>
                    <Tab eventKey="category" title="Category">
                        <ManageGameCategory settings={settings} game={game}/>
                    </Tab>
                    <Tab eventKey="stores" title="Stores">
                        <ManageGameLinks settings={settings} game={game}/>
                    </Tab>
                </Tabs>

                <br/>

                <hr/>

                <div>
                    {hasChat ? <div class="alert alert-success"><h2>[IMPORTANT] Your game has chat available</h2></div> :
                        <div class="alert alert-warning">
                            <h3>Do you want to open conversation beneath your app?</h3>
                            <form onSubmit={this.createChat.bind(this)}>
                                <input class="btn btn-warning" type="submit" value="Create chat"/>
                            </form>
                        </div>
                    }
                </div>

                <NavLink className="btn btn-outline-primary"
                    to={"/company/" + game.publisher.id.toString() + "/game/" + game.id.toString() + "/actions"}
                >
                    Recent activity
                </NavLink>
            </div>;
        }

        return <Container>
            <Row>
                <Col>
                    {content}
                </Col>
            </Row>
        </Container>;
    }
}
